<div style="overflow: visible; text-align: left; width:100%; height: 120px;" [ngStyle]="{'height': height + 'px'}" [id]="chartId">
</div>